import axios from 'axios'

// Get logs
const get = async (iniDate, endDate, from = null, level = null) => {
  const { data } = await axios.get(
    `${process.env.VUE_APP_API}/log`,
    { params: { iniDate, endDate, from, level } }
  )
  return data
}

export {
  get
}
